import axios from "axios";
import { apiBaseURL } from "./ApiHelper";
export const Config = () => {
  let token = JSON.parse(localStorage.getItem("token"));
  return axios.create({
    baseURL: `${apiBaseURL}`,
    headers: {
      authorization: `Bearer ${token}`,
    },
  });
};
export const AuthOHelper = () => {
  return axios.create({
    baseURL: `${apiBaseURL}`,
  });
};
